import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { ConstantsService } from "./constants.service";
import { State } from "../../app-store";
import { UserService } from "./user.service";
import { ICurrentUser } from "../models/interfaces/current-user";
import {
  SetCurrentUser,
  getCurrentUser,
  ClearCurrentUser,
} from "../../app-store/current-user";
import { DataService } from "./dataservice";
import { Observable, combineLatest, forkJoin, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Urls } from "../../shared/Urls";
import { catchError, map } from "rxjs/operators";
import * as _ from "underscore";
import { IStation } from "../models/interfaces/station";
import moment from 'moment';
import { IReferralFormQuestionGroup } from "../models/interfaces/referral-form-question-group";
import { IQuestion } from "../models/interfaces/question";
import { OptionTypes } from "../enums/option-types.enum";

@Injectable({
  providedIn: "root",
})
export class UtilitiesService {
  currentUser: ICurrentUser;

  constructor(
    private store: Store<State>,
    private constantsService: ConstantsService,
    private userService: UserService,
    private dataService: DataService,
    private http: HttpClient
  ) { }

  convertUtcToLocalDate(date: Date | undefined | null) {
    if (date === undefined || date === null) {
      return null;
    }

    const stillUtc = moment.utc(date.toString()).toDate();
    return moment(stillUtc).local().format('MM-DD-YYYY HH:mm:ss');
  }

  saveUserInStore(username: string) {
    this.userService.getClaims(username).subscribe((response) => {
      const user: ICurrentUser = {
        userName: username,
        roles: response[0],
        dbUser: response[1],
      };
      console.log("current user to go in store", user);
      this.store.dispatch(SetCurrentUser({ payload: user }));
      if (this.isCurrentUserAdmin()) {
        this.dataService.setCurrentUserAsAdminUser(true);
      }
    });
  }

  isUserLoggedIn(): Observable<boolean> {
    return combineLatest([
      this.isCurrentUserAdmin()
    ]).pipe(
      map(([isAdmin]) => isAdmin),
      catchError(error => {
        console.error('Error in isUserLoggedIn:', error);
        return of(false);
      })
    );
  }

  isCurrentUserAdmin(): Observable<boolean> {
    return this.store.select(getCurrentUser).pipe(
      map((user: ICurrentUser | null) => {
        if (
          user &&
          user.roles &&
          user.roles.filter(
            (x: { id: string; }) => x.id === this.constantsService.SafeAndWell_Admin__AD_GroupId
          ).length > 0
        ) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  clearStateOnLogOut() {
    this.store.dispatch(ClearCurrentUser());
  }

  private parseJwt(token: string) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  }

  isQuestionAnswerValid(question: IQuestion): boolean {
    let valid = true;

    // check for text type questions 1st and verify there is an input for required questions.
    if (
      question.options[0].optionTypeId === OptionTypes.Text ||
      question.options[0].optionTypeId === OptionTypes.TextMultipleLines
    ) {
      if (question.options[0].optionValues[0].description === "") {
        console.log("Text Question" + question.description + " is Invalid");
        valid = false;
      }
      return valid;
    }

    const optionValues = question.options[0].optionValues;

    // case no option is selected
    if (optionValues.filter((ov) => ov.isSelected === true).length < 1) {
      console.log(question.description + "is Invalid");
      valid = false;
      return valid;
    }

    // case an option is selected and no child question group
    for (const ov of optionValues) {
      if (ov.isSelected === true && ov.optionValueQuestionGroups.length === 0) {
        valid = true;
        return valid;
      }
    }

    // case an option is selected and question has child question group
    for (const ov of optionValues) {
      if (ov.isSelected === true && ov.optionValueQuestionGroups.length > 0) {
        // get questions of child question group
        var childQuestionGroupRequiredQuestions: IQuestion[];
        if (ov.optionValueQuestionGroups[0].questionGroup
          && ov.optionValueQuestionGroups[0].questionGroup.questionGroupQuestions
          && ov.optionValueQuestionGroups[0].questionGroup.questionGroupQuestions.length > 0) {
          childQuestionGroupRequiredQuestions = _.flatten(
            ov.optionValueQuestionGroups[0].questionGroup.questionGroupQuestions
              .map((x) => x.question)
              .filter((x) => x.isRequired)
          );

          // iterate over the child questions
          for (const childGroupQuestion of childQuestionGroupRequiredQuestions) {
            if (this.isQuestionAnswerValid(childGroupQuestion) === false) {
              console.log(
                childGroupQuestion.description + "from child group is Invalid"
              );
              valid = false;
              return valid;
            }
          }
        }
      }
    }
    return valid;
  }

  getRequiredQuestionFromQuestionGroup(
    quesionGroups: IReferralFormQuestionGroup[]
  ): IQuestion[] {
    const questions = _.flatten(
      quesionGroups
        .map((x) => x.questionGroup)
        .map((x) => x.questionGroupQuestions)
    )
      .map((x) => x.question)
      .filter((x) => x.isRequired);
    return questions;
  }
}
